module.exports = __webpack_public_path__ + "static/media/community-second@3x.ed027de0.jpg";